module.exports = __webpack_public_path__ + "static/media/激光切割机械臂.e9332611.png";